module.exports = __webpack_public_path__ + "static/media/fb-polos.6aad288a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/fb-polos.svg
// module id = 759
// module chunks = 0